<template>
    <div>
        <b-card no-body class="mb-2">
            <b-card-header header-tag="header" class="p-3 d-flex justify-content-between" role="tab">

                <div class="d-flex gap-2 align-items-center flex-grow-1 text-dark" v-b-toggle="'module-' + module.id">
                    <svg class="when-closed" height="20px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
                        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                    </svg>
                    <svg class="when-open" height="20px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" >
                        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                      </svg>


                    <h5 class="font-weight-bold-500 p-0 m-0 " >
                        {{ module.name }}
                    </h5>

                </div>

                <div class="d-flex align-items-center">
                    <span class="">
                        <b>{{ module.lessons_count }}</b> Aulas
                    </span>

                    <div class="ml-2 d-md-none dropdown">
                        <div class="" type="button" :id="'module-drop-'+ module.id" data-bs-toggle="dropdown" aria-expanded="false">
                            <svg height="24px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
                              </svg>
                        </div>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                          <li><button class="dropdown-item" @click="orderUp">Mover para cima</button></li>
                          <li><button class="dropdown-item" @click="orderDown">Mover para baixo</button></li>
                          <li><button class="dropdown-item" @click="openModalEditModule">Editar Módulo</button></li>
                          <li><button class="dropdown-item text-danger" @click="openModalDestroyModule">Excluir Módulo</button></li>
                        </ul>
                    </div>
                    <!-- order up -->
                    <a href="javascript:void(1)" @click="orderUp" class="ml-2 d-none d-md-flex text-primary" title="Mover para cima">
                        <i class="fas fa-arrow-up"></i>
                    </a>

                    <!-- order down -->
                    <a href="javascript:void(1)" @click="orderDown" class="ml-2 d-none d-md-flex text-primary" title="Mover para baixo">
                        <i class="fas fa-arrow-down"></i>
                    </a>

                    <a href="javascript:void(1)" @click="openModalEditModule" class="ml-2 d-none d-md-flex text-primary" title="Editar Módulo">
                        <i class="fas fa-edit"></i>
                    </a>

                    <a href="javascript:void(1)" @click="openModalDestroyModule" class="ml-2 d-none d-md-flex text-danger" title="Excluir Módulo">
                        <i class="fas fa-trash"></i>
                    </a>
                </div>
            </b-card-header>
            <b-collapse :id="'module-' + module.id" accordion="ecorrecao" role="tabpanel">
                <b-card-body>
                    <div v-if="module.lessons.length === 0" class="bg-light rounded border p-3 text-left">
                        Você ainda não tem aulas neste módulo. Faça o upload de uma aula para começar.
                    </div>

                    <div v-for="lesson in module.lessons" :key="lesson.id">
                        <lesson-item :lesson="lesson" :module="module" @updated="refresh"></lesson-item>
                    </div>

                    <div class="mt-3">
                        <b-button variant="outline-primary" @click="openModalCreateLesson">
                            <i class="fas fa-plus mr-1"></i> Nova Aula
                        </b-button>
                    </div>
                </b-card-body>
            </b-collapse>
        </b-card>

        <!-- Edit Module Modal -->
        <edit @updated="refresh" :module="module"></edit>

        <!-- Destroy Module Modal -->
        <destroy @destroyed="refresh" :module="module"></destroy>

        <!-- Create Lesson Modal -->
        <create-lesson @created="refresh" :module="module"></create-lesson>
    </div>
</template>

<script>
import Edit from './Edit'
import Destroy from "./Destroy";
import LessonItem from "./LessonItem";
import CreateLesson from "./CreateLesson";

export default {
    props: ['module'],
    components: {
        Edit,
        Destroy,
        LessonItem,
        CreateLesson,
    },
    data() {
        return {
            loading: false,
        }
    },
    methods: {
        openModalEditModule() {
            this.$root.$emit('open-modal-edit-module-' + this.module.id);
        },

        openModalDestroyModule() {
            this.$root.$emit('open-modal-destroy-module-' + this.module.id);
        },

        openModalCreateLesson() {
            this.$root.$emit('open-modal-create-lesson-' + this.module.id);
        },

        refresh() {
            this.$emit('updated');
        },

        orderUp() {
            this.$emit('orderUp', this.module.id);
        },

        orderDown() {
            this.$emit('orderDown', this.module.id);
        }
    }
}
</script>

<style scoped>
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>
